import { PosterProject } from "PosterEditor/model/poster-project";
import { useCheckoutPricing } from "hooks/use-checkout-pricing";
import { ProjectPreview } from "components/common/project-preview";
import styles from "./order-detail.module.css";

import { useEffect, useState } from "react";
import { Order } from "entity-store/orders-store/use-orders-store";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import {
  SizePreset,
  useSizePresets,
} from "PosterEditor/model/size-presets/size-preset";

interface OrderDetailProps {
  order: Order;
  onClickPay: () => void;
}

export const OrderDetail = (props: OrderDetailProps) => {
  const { formattedPriceForProjects } = useCheckoutPricing();
  const { loadProject } = useProjectStore();

  const projects = props.order.projectIDs
    .map((id) => loadProject(id))
    .filter((p): p is PosterProject => p !== undefined);

  return (
    <div className={styles.list}>
      {props.order.projectIDs.map((id) => (
        <OrderProject key={id} projectID={id} />
      ))}
      <div className={styles.listFooter}>
        <div className={styles.listFooterTrailingContent}>
          <span className={styles.totalPrice}>
            {formattedPriceForProjects(projects)}
          </span>
        </div>
      </div>
    </div>
  );
};

interface OrderProjectProps {
  projectID: string;
}

const OrderProject = (props: OrderProjectProps) => {
  const { loadProject } = useProjectStore();
  const { formattedPriceForProject } = useCheckoutPricing();
  const [project, setProject] = useState<PosterProject | undefined>();
  const { sizePresetFromProject } = useSizePresets();
  const [sizePreset, setSizePreset] = useState<SizePreset | undefined>();

  useEffect(() => {
    const project = loadProject(props.projectID);
    if (project) {
      setProject(project);
      const size = sizePresetFromProject(project);
      setSizePreset(size);
    }
  }, []);

  if (!project) {
    return null;
  }

  const price = formattedPriceForProject(project);
  const size = sizePreset?.sizeDescription ?? "-";
  const material = sizePreset?.materialDescription ?? "";

  return (
    <div className={styles.listItem}>
      <div className={styles.listItemPreviewAsset}>
        <ProjectPreview project={project} size={{ width: 140, height: 140 }} />
      </div>
      <div className={styles.listItemDescriptionContainer}>
        <h1>Alumninum dibond print</h1>
        <h2>
          <b>{size}</b>
        </h2>
        <p className={styles.tiny}>{material}</p>
      </div>
      <div className={styles.listItemtTrailingContainer}>
        <span className={styles.price}>{price}</span>
      </div>
    </div>
  );
};
